import React from 'react';
import { SearchResponse } from '@algolia/client-search';
import { AlgoliaProduct } from 'models/products';
import { algoliaIndex } from 'services/algolia';
import { cache } from 'services/productsCache/fsCache';
import { ProductDetailProps, Detail } from 'features/products/Detail/Detail';
import { getFile } from 'services/aws/s3';
import { productsDBS3FilePath } from 'constants/paths';

type PathType = {
  params: { slug: string };
};

const bucketName = process.env.PRODUCTSDB_BUCKETNAME || '';

export async function getStaticPaths(): Promise<{
  paths: PathType[];
  fallback: boolean | 'blocking';
}> {
  let products = await cache.getAll();

  if (!products && process.env.ENVIRONMENT !== 'uitest') {
    const res = await getFile(bucketName, productsDBS3FilePath);
    if (res && res.Body) {
      const hits = res.Body.toString();
      await cache.set(JSON.parse(hits));
      products = await cache.getAll();
    }
  }

  // for building in circle, deliberately verbose so we can come back to it
  if (process.env.ENVIRONMENT === 'uitest') {
    products = {};
  }

  const paths = Object.keys(products).map((key: string) => ({
    params: {
      slug: products[key].urlSlug,
    },
  }));
  return {
    paths,
    fallback: 'blocking',
  };
}

export async function getStaticProps({
  params: { slug },
}: PathType): Promise<{ props: ProductDetailProps; revalidate: number }> {
  let hit = await cache.get(slug as string);

  if (!hit) {
    // eslint-disable-next-line no-console
    console.log(`algolia search called on static generator, slug: ${slug}`);
    const res: SearchResponse = await algoliaIndex.search(slug, { analytics: false });
    hit = res.hits[0] as AlgoliaProduct;
  }

  return {
    props: {
      hit,
    },
    revalidate: 60,
  };
}

const ProductDetail: React.FC<ProductDetailProps> = props => {
  return <Detail {...props} />;
};

export default ProductDetail;
